import { ColorHex } from '@carboncopyco/ui';
import { integersFormatter, secondsToHHmmss } from '@carboncopyco/utils';
import { StatsCard } from '../StatsCard';
import { useGetTotalsData } from '../hooks';

const title = 'Tour visits';

export const ToursTotalVisits = () => {
  const {
    data,
    isLoading,
    isLoadingPrevData,
    getPercentages,
    getDescription,
    chartData,
    isError,
  } = useGetTotalsData({
    resourceTypes: ['tour'],
    assetType: 'tour',
  });

  const { values } = data ?? {};

  return (
    <StatsCard
      isError={isError}
      isEmpty={!isLoading && !values?.occurrences}
      title={title}
    >
      <StatsCard.Graph
        title={title}
        kpiNumber={
          values?.occurrences ? integersFormatter(values.occurrences) : ''
        }
        kpiPercentage={getPercentages('occurrences')}
        kpiRawNumber={values?.occurrences}
        description={getDescription('occurrences')}
        lineChartData={chartData}
        loading={isLoading || isLoadingPrevData}
        negative={Number(getPercentages('occurrences')) < 0}
        color={ColorHex.accent1200}
      />
      <StatsCard.Item
        title="Median duration"
        value={
          values?.medianDuration ? secondsToHHmmss(values.medianDuration) : ''
        }
        loading={isLoading || isLoadingPrevData}
        percentage={getPercentages('medianDuration')}
        negative={Number(getPercentages('medianDuration')) < 0}
        description={getDescription('medianDuration')}
      />
      <StatsCard.Item
        title="Completion rate"
        value={
          values?.avgCompletionRate
            ? `${values.avgCompletionRate.toFixed()}%`
            : ''
        }
        percentage={getPercentages('avgCompletionRate')}
        negative={Number(getPercentages('avgCompletionRate')) < 0}
        description={getDescription('avgCompletionRate')}
        loading={isLoading || isLoadingPrevData}
      />
      <StatsCard.Item
        title="Bounce rate"
        value={
          values?.avgBounceRate ? `${values.avgBounceRate.toFixed()}%` : ''
        }
        percentage={getPercentages('avgBounceRate')}
        negative={Number(getPercentages('avgBounceRate')) < 0}
        description={getDescription('avgBounceRate')}
        loading={isLoading || isLoadingPrevData}
        reverseTrendColor
      />
    </StatsCard>
  );
};
